import React from 'react';
import { HomeIcon } from 'lucide-react';
export const LandPropertyWidget = () => {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full" data-id="element-1987">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-1988">
        <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-1989">
          <HomeIcon className="h-5 w-5 text-blue-500 mr-2" data-id="element-1990" />
          Land & Property
        </h2>
      </div>
      <div className="p-6" data-id="element-1991">
        <div className="flex flex-col space-y-4" data-id="element-1992">
          <div className="flex justify-between items-center" data-id="element-1993">
            <span className="text-sm text-gray-600" data-id="element-1994">
              New Title Applications
            </span>
            <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-1995">
              12
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-1996">
            <span className="text-sm text-gray-600" data-id="element-1997">
              Pending Building Permits
            </span>
            <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-1998">
              23
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-1999">
            <span className="text-sm text-gray-600" data-id="element-2000">Inspections Scheduled</span>
            <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2001">
              8
            </span>
          </div>
          <div className="mt-4 bg-gray-100 rounded-lg p-3" data-id="element-2002">
            <p className="text-xs text-gray-700 font-medium" data-id="element-2003">Recent Activity</p>
            <div className="mt-2 text-xs text-gray-600" data-id="element-2004">
              <p data-id="element-2005">• Zoning change approved for District 5</p>
              <p data-id="element-2006">• 3 new subdivision applications received</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex border-t border-gray-200 divide-x divide-gray-200" data-id="element-2007">
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-2008">
          View Applications
        </a>
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-2009">
          Start New Permit
        </a>
      </div>
    </div>;
};